import {Injectable} from '@angular/core';
import {DataCoreService, DlistDto} from '@dabnet-kamu/libs/ui';
import {BehaviorSubject} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {ControlConditionModel} from "../../../models/gen-control.model";

@Injectable()
export class TebFonksiyonService {
  public period!: number;
  public isReadOnly!: boolean;
  public isBindCheck!: boolean;
  public controlCondition: ControlConditionModel[];
  public useOrCondition:boolean=false
  kurumsalKod: string; // Kurumsal kodu saklamak için değişken

  public _gridControlsList: BehaviorSubject<DlistDto | null> = new BehaviorSubject(null);
  public gridControlsList$ = this._gridControlsList.asObservable();

  constructor(private dataCoreService: DataCoreService, private _httpClient: HttpClient) {
  }


  setParams(period: number,controlCondition?:ControlConditionModel[],useOrCondition?:boolean, isReadOnly?:boolean, isBindCheck?:boolean, kurumsalKod?: string) {
    this.period = period;
    this.controlCondition= controlCondition
    this.useOrCondition=useOrCondition
    this.isReadOnly = isReadOnly;
    this.isBindCheck = isBindCheck;
    this.kurumsalKod= kurumsalKod
  }


  getData(
    code: string,
    control: any,
    period: number,
    baseEntity?: string,
    isSetData?: boolean,
  ) {
    let dataSource: any;
    let tableName = "";
    const filterArr: any[] = [];

    if (this.isBindCheck && this.isReadOnly) {
      tableName = control.showEntity
        ? control.showEntity
        : control.dlistMetadata.baseEntity;
      dataSource = this.dataCoreService.getOData(tableName);
    } else {
      const queryParams: string[] = [];

      // Donem parametresi → her zaman query’de
      if (period) {
        queryParams.push(`Donem=${period}`);
      }

      // Kurumsal parametresi (sadece gerekiyorsa)
      if (this.kurumsalKod) {
        queryParams.push(`Kurumsal=${this.kurumsalKod}`);
      }

      // Query string oluştur
      if (queryParams.length > 0) {
        tableName = `${baseEntity}?${queryParams.join("&")}`;
      } else {
        tableName = baseEntity;
      }

      dataSource = this.dataCoreService.getOData(tableName);

      // FonksiyonelKod uzunluk filtresi
      filterArr.push(["FonksiyonelKod.Length", ">=", 4]);

      // Ek koşullar
      if (this.controlCondition) {
        if (this.useOrCondition) {
          const combinedOrFilters = this.controlCondition
            .map((item: any) => [
              item.conditionColName,
              item.conditionColSymbol,
              item.conditionColText,
            ])
            .reduce(
              (prev, current) => (prev ? [prev, "or", current] : current),
              null
            );

          if (combinedOrFilters) {
            filterArr.push(combinedOrFilters);
          }
        } else {
          this.controlCondition.forEach((item: any) => {
            filterArr.push([
              item.conditionColName,
              item.conditionColSymbol,
              item.conditionColText,
            ]);
          });
        }
      }
    }

    dataSource.select();

    // Eğer arama kodu varsa sadece FonksiyonelKod filtresi uygula
    if (code) {
      filterArr.push(["FonksiyonelKod", "=", code]);
    }

    // filter sadece ek koşullar ve FonksiyonelKod için
    dataSource.filter(filterArr);

    return dataSource;
  }

}
